export default "__VITE_ASSET__DezkbjAi__"